import { render, staticRenderFns } from "./closing.pug?vue&type=template&id=582cfb93&lang=pug&"
import script from "./closing.js?vue&type=script&lang=js&"
export * from "./closing.js?vue&type=script&lang=js&"
import style0 from "./closing.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582cfb93')) {
      api.createRecord('582cfb93', component.options)
    } else {
      api.reload('582cfb93', component.options)
    }
    module.hot.accept("./closing.pug?vue&type=template&id=582cfb93&lang=pug&", function () {
      api.rerender('582cfb93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/closing/index.vue"
export default component.exports